// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606230150/js/" + chunkId + "." + {"44":"fc45419b","225":"cd95f0ca","481":"5654a10c","486":"5b0c9766","770":"4a4fa7b8"}[chunkId] + ".0.6278696706097023.chunk.js";
};